module.exports = __webpack_public_path__ + "static/media/expand-arrow-1.cee6d3b9.svg";